module.exports = __webpack_public_path__ + "static/assets/91f179b258bd0c1953f8fe6129d9615f.svg";